import { render, staticRenderFns } from "./LocalizedInput.vue?vue&type=template&id=47edbbc0&scoped=true"
import script from "./LocalizedInput.vue?vue&type=script&lang=js"
export * from "./LocalizedInput.vue?vue&type=script&lang=js"
import style0 from "./LocalizedInput.vue?vue&type=style&index=0&id=47edbbc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47edbbc0",
  null
  
)

export default component.exports